import React from 'react';
import PresenceConfirmModal from './PresenceConfirmModal';
import { useInactivityRules } from './useInactivityRules';

const InactivityRulesHost: React.FC = () => {
    const { prompt, manualOooSignsOut, onConfirm, onTimeout } = useInactivityRules();
    return <PresenceConfirmModal prompt={prompt} manualOooSignsOut={manualOooSignsOut} onConfirm={onConfirm} onTimeout={onTimeout} />;
};

export default InactivityRulesHost;
